<!--suppress ALL -->

<template>
  <el-dialog top="10px"
    title="选择模版"
    :visible.sync="isVisible"
    width="60%"
    :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true">

    <el-table stripe border :data="items" style="width: 100%; margin-top: 30px">
      <el-table-column width="700px" prop="text" label="文本"></el-table-column>
<!--      <el-table-column prop="createTime" label="添加时间"></el-table-column>-->
      <el-table-column prop="opt" label="操作">
        <template slot-scope="scope">
          <el-button @click="pick(scope.row)" type="text">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="bottom_space"></el-row>
    <el-pagination
      background
      :page-size="pageSize"
      layout="prev, pager, next"
      :total="total"
      @current-change="changePage">
    </el-pagination>

  </el-dialog>
</template>


<script>


export default {
  name: 'TemplatePick',
  data() {
    return {
      pageSize: 10,
      total: 0,
      currentPage: 0,
      items: [],
      isVisible: false,
      library_id:'',
    }
  },
  mounted() {
  },
  created: function () {
  },
  components: {

  },
  methods: {

    init(library_id){
      this.library_id = library_id
      this.isVisible = true;
      this.getItemList()
    },

    pick(item){
      this.$emit("refresh",item.text)
      this.isVisible = false
    },

    changePage: function (event) {
      this.currentPage = event;
      this.getItemList();
    },

    getItemList: function () {
      let t = this;
      this.$get(
        {
          context: t,
          path: '/aigc/template/list/',
          params: {
            library_id: this.library_id,
            size: t.pageSize,
            start: t.currentPage
          },
          success: function (data) {
            t.items = data.items;
            t.total = data.count;
          }
        }
      )
    },


  }

}
</script>

<style scoped >
@import '../../assets/global.css';
</style>
